import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
var Badge = function (_a) {
    var children = _a.children, size = _a.size, countAlert = _a.countAlert, color = _a.color, className = _a.className, isBorder = _a.isBorder, to = _a.to, href = _a.href, title = _a.title;
    var renderBadgeContent = useMemo(function () {
        return (React.createElement("div", { title: title, className: 'badge badge-' +
                size +
                ' ' +
                ((color || 'primary') + " ") +
                ' ' +
                (isBorder ? 'gr-border' : '') +
                ' ' +
                (className ? className : '') },
            React.createElement("div", { className: 'badge-container' },
                children && React.createElement("span", { className: size === 'l' ? 'mr-x1' : 'mr-i-x1' }, children),
                React.createElement("p", { className: 'quantity-indicator mb-0' }, countAlert))));
    }, [children, className, color, countAlert, isBorder, size, title]);
    var renderContent = useMemo(function () {
        if (to) {
            return React.createElement(Link, { to: to }, renderBadgeContent);
        }
        else if (href) {
            return React.createElement("a", { href: href }, renderBadgeContent);
        }
        else {
            return React.createElement("div", null, renderBadgeContent);
        }
    }, [href, renderBadgeContent, to]);
    return React.createElement(React.Fragment, null, renderContent);
};
export { Badge };
//# sourceMappingURL=Badge.js.map